import { render, staticRenderFns } from "./MyAttendedLectures.vue?vue&type=template&id=5605b672&scoped=true&"
import script from "./MyAttendedLectures.vue?vue&type=script&lang=js&"
export * from "./MyAttendedLectures.vue?vue&type=script&lang=js&"
import style0 from "./MyAttendedLectures.vue?vue&type=style&index=0&id=5605b672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605b672",
  null
  
)

export default component.exports